import React, { useState } from "react";
import { Button } from "reactstrap";
import { Tabs, Tab } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../CommonComponents/RightDrawer";
import { GSTfieldsConfig, GSTFieldGroups } from "../../utils/fieldsConfig";
import { formatDate } from "../../utils/commonutils";
import ModuleFollowups from "../CommonComponents/ModuleFollowups";
import AttachmentPanel from "../CommonComponents/AttachmentPanel";

const asId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value._id) return String(value._id);
  return String(value);
};

const displayValue = (name, data) => {
  if (name === "taxPayerName") {
    return data.customerId?.companyName || data.customerId?.name || "—";
  }
  if (name === "assignedTo") {
    return data.assignedTo?.name || "—";
  }
  if (GSTfieldsConfig[name]?.type === "date") return formatDate(data[name]) || "—";
  if (name === "amount" && data[name]) {
    const n = Number(data[name]);
    return Number.isFinite(n) ? `₹${n.toLocaleString()}` : `₹${data[name]}`;
  }
  return data[name] || "—";
};

const GSTCaseDetailModal = ({ isOpen, onClose, caseData, props }) => {
  const [tabValue, setTabValue] = useState(0);
  const history = useHistory();
  const data = caseData || {};
  const customerId = asId(data.customerId);
  const inquiryId = asId(data.inquiryId);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose} kicker="GST litigation">
        {data.caseId || data.subject || "Case details"}
      </ModalHeader>
      <ModalBody>
        <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)}>
          <Tab label="Details" />
          <Tab label="Follow-ups" />
          <Tab label="Attachments" />
        </Tabs>
        {tabValue === 0 && (
          <div>
            {(customerId || inquiryId) && (
              <div className="drawer-section">
                <h3 className="drawer-section-title">Linked records</h3>
                {data.customerId?.companyName || data.customerId?.name ? (
                  <div className="drawer-kv">
                    <span className="drawer-kv-label">Customer</span>
                    <span className="drawer-kv-value">
                      {customerId ? (
                        <button
                          type="button"
                          className="text-[13px] font-semibold text-[#1a3366] hover:underline bg-transparent border-0 p-0"
                          onClick={() => history.push(`/customers/${customerId}`)}
                        >
                          {data.customerId.companyName || data.customerId.name}
                        </button>
                      ) : (
                        data.customerId.companyName || data.customerId.name
                      )}
                    </span>
                  </div>
                ) : null}
                {inquiryId ? (
                  <div className="drawer-kv">
                    <span className="drawer-kv-label">Source inquiry</span>
                    <span className="drawer-kv-value">
                      <button
                        type="button"
                        className="text-[13px] font-semibold text-[#1a3366] hover:underline bg-transparent border-0 p-0"
                        onClick={() => history.push(`/inquiriedetail/${inquiryId}`)}
                      >
                        Open inquiry
                      </button>
                    </span>
                  </div>
                ) : null}
              </div>
            )}
            {GSTFieldGroups.map((group) => (
              <div className="drawer-section" key={group.title}>
                <h3 className="drawer-section-title">{group.title}</h3>
                {group.fields.map((name) => (
                  <div className="drawer-kv" key={name}>
                    <span className="drawer-kv-label">{GSTfieldsConfig[name]?.label || name}</span>
                    <span className="drawer-kv-value">{displayValue(name, data)}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        {tabValue === 1 && data._id && (
          <ModuleFollowups
            moduleName="case_management"
            recordId={data._id}
            customerId={customerId}
            props={props}
          />
        )}
        {tabValue === 2 && data._id && (
          <AttachmentPanel moduleName="case_management" recordId={data._id} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-border" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GSTCaseDetailModal;
